// ================= 首页推荐 =================
export const recommendListData = [
  {
    id: 1,
    title: "建设工程施工合同纠纷",
    content: "因建设工程施工合同履行过程中产生的工程款支付、质量责任、工期违约等争议形成的典型案例。",
    tags: ["建设工程"],
    icon: require("@/assets/casesearchImg/Background1.png")
  },
  {
    id: 2,
    title: "劳动争议纠纷",
    content: "围绕劳动关系确认、解除劳动合同、经济补偿金等问题形成的典型裁判案例。",
    tags: ["劳动争议"],
    icon: require("@/assets/casesearchImg/Background2.png")
  },
  {
    id: 3,
    title: "民间借贷纠纷",
    content: "涉及借款合同效力、利息计算、担保责任等相关裁判观点。",
    tags: ["借贷"],
    icon: require("@/assets/casesearchImg/Background3.png")
  },
  {
    id: 4,
    title: "买卖合同纠纷",
    content: "关于货款支付、违约责任、合同解除等典型案例。",
    tags: ["买卖合同"],
    icon: require("@/assets/casesearchImg/Background4.png")
  },
  {
    id: 5,
    title: "机动车交通事故责任纠纷",
    content: "涉及交通事故责任划分、人身损害赔偿等相关裁判案例。",
    tags: ["交通事故"],
    icon: require("@/assets/casesearchImg/Background5.png")
  },
  {
    id: 6,
    title: "物业服务合同纠纷",
    content: "围绕物业服务费、物业管理责任等形成的典型案例。",
    tags: ["物业服务"],
    icon: require("@/assets/casesearchImg/Background6.png")
  }
]

// ================= 首页统计 =================
export const statisticsData = [
  {
    icon: require("@/assets/casesearchImg/iconlist1.png"),
    title: "案例总数",
    value: "6800万+"
  },
  {
    icon: require("@/assets/casesearchImg/iconlist2.png"),
    title: "法律法规",
    value: "120万+"
  },
  {
    icon: require("@/assets/casesearchImg/iconlist3.png"),
    title: "裁判文书",
    value: "2300万+"
  },
  {
    icon: require("@/assets/casesearchImg/iconlist4.png"),
    title: "持续更新",
    value: "24h"
  }
]

// ================= 检索结果 =================
export const searchResultData = [
  {
    id: 1,
    title: "建设工程施工合同纠纷中工程价款结算规则研究",
    court: "最高人民法院",
    caseNo: "（2024）最高法民终123号",
    date: "2024-03-18",
    summary:
      "本案认为，在建设工程施工合同纠纷中，工程价款结算应依据双方合同约定、工程签证、竣工验收情况及实际履行情况综合认定。",
    tags: ["建设工程", "工程款", "施工合同"],
    similarity: 98
  },
  {
    id: 2,
    title: "建设工程施工合同解除后的工程价款认定",
    court: "北京市高级人民法院",
    caseNo: "（2023）京民终258号",
    date: "2023-11-06",
    summary:
      "双方解除施工合同后，已完成工程部分仍应依据实际完成工程量进行结算，未完成部分不再支持继续履行。",
    tags: ["合同解除", "工程款", "建设工程"],
    similarity: 96
  },
  {
    id: 3,
    title: "建设工程质量责任纠纷裁判规则",
    court: "上海市高级人民法院",
    caseNo: "（2022）沪民终105号",
    date: "2022-09-12",
    summary:
      "承包人交付工程存在质量问题的，应承担维修、返工及赔偿责任；发包人主张质量缺陷应承担初步举证责任。",
    tags: ["工程质量", "建设工程"],
    similarity: 94
  },
  {
    id: 4,
    title: "工程款优先受偿权认定",
    court: "广东省高级人民法院",
    caseNo: "（2024）粤民终88号",
    date: "2024-05-09",
    summary:
      "建设工程承包人依法享有工程价款优先受偿权，但应满足法律规定的期限及工程性质要求。",
    tags: ["优先受偿", "工程款"],
    similarity: 93
  },
  {
    id: 5,
    title: "建设工程实际施工人权益保护",
    court: "江苏省高级人民法院",
    caseNo: "（2023）苏民终456号",
    date: "2023-06-21",
    summary:
      "实际施工人在符合法律规定条件下，可以突破合同相对性向发包人主张工程价款。",
    tags: ["实际施工人", "工程款"],
    similarity: 91
  },
  {
    id: 6,
    title: "工程签证效力认定",
    court: "浙江省高级人民法院",
    caseNo: "（2022）浙民终89号",
    date: "2022-12-18",
    summary:
      "工程签证属于工程结算的重要依据，但需结合双方实际履行情况进行综合审查。",
    tags: ["工程签证", "建设工程"],
    similarity: 89
  }
]
export const analysisData = [
  {
    id: 1,
    type: "answer",
    title: "回答及结论",
    caseCount: 48,
    updateTime: "刚刚",
    content:
      "员工在职期间未经公司许可，从事与公司相同或存在直接竞争关系的业务，若其劳动合同、保密协议或公司规章中已明确约定竞业限制义务，通常可能构成违约。法院会综合审查岗位性质、接触商业秘密程度、实际经营行为及公司损失等因素。"
  },
  {
    id: 2,
    type: "focus",
    title: "争议焦点具体分析",
    children: [
      {
        title: "是否存在有效的竞业限制或忠实义务约定",
        content:
          "需要确认劳动合同、保密协议以及单位制度中是否对在职期间的竞业行为作出明确约定。"
      },
      {
        title: "员工是否实施了竞争行为",
        content:
          "包括设立同类公司、实际经营、为竞争主体提供服务、使用原公司客户资源等。"
      },
      {
        title: "违约行为与损失之间是否存在关联",
        content:
          "公司主张赔偿时，应对客户流失、交易机会损失或商业秘密泄露等事实承担举证责任。"
      }
    ]
  },
  {
    id: 3,
    type: "core",
    title: "核心案例剖析",
    content:
      "多数裁判观点认为，在职期间的竞业义务来源于劳动者的忠实义务及双方明确约定。若员工实际控制同业主体、获取利益并影响原公司业务，法院更可能认定其构成违约。"
  }
]
/**
 * 精选案例
 */
export const caseListData = [
  {
    id: 1,
    title: "某科技公司与张某竞业限制纠纷案",
    caseNo: "（2024）沪01民终32689号",
    court: "上海市第一中级人民法院",
    date: "2024-06-18",
    summary:
      "劳动者在职期间实际经营与用人单位主营业务相同的企业，并使用公司客户信息承接业务，违反了劳动合同约定及竞业义务。",

    tags: [
      "案情摘要",
      "认定事实",
      "本院认为",
      "裁判结果"
    ],

    dispute: "劳动争议",

    trial: "二审",

    area: "上海",

    aiLevel: "高度相关",

    status: "已生效",

    favorite: false
  },

  {
    id: 2,
    title: "李某与某咨询公司劳动合同纠纷案",
    caseNo: "（2023）粤03民终11902号",
    court: "深圳市中级人民法院",
    date: "2023-11-06",

    summary:
      "劳动者离职后与原单位从事相同性质工作，但公司未能证明其利用商业秘密或客户资源开展竞争行为。",

    tags: [
      "案情摘要",
      "认定事实",
      "本院认为",
      "裁判结果"
    ],

    dispute: "劳动争议",

    trial: "二审",

    area: "广东",

    aiLevel: "较高相关",

    status: "已生效",

    favorite: true
  },

  {
    id: 3,
    title: "王某与某网络公司竞业限制纠纷案",
    caseNo: "（2022）京03民终88241号",
    court: "北京市第三中级人民法院",
    date: "2022-09-12",

    summary:
      "劳动者违反竞业协议，利用原单位核心客户资源开展经营活动，应承担违约责任并继续履行保密义务。",

    tags: [
      "案情摘要",
      "认定事实",
      "本院认为",
      "裁判结果"
    ],

    dispute: "劳动争议",

    trial: "二审",

    area: "北京",

    aiLevel: "高度相关",

    status: "已生效",

    favorite: false
  },

  {
    id: 4,
    title: "陈某与某软件公司竞业限制纠纷案",
    caseNo: "（2021）浙01民终55209号",
    court: "杭州市中级人民法院",
    date: "2021-08-26",

    summary:
      "劳动者自营企业经营范围与原单位主营业务存在高度重合，法院综合认定违反竞业限制协议。",

    tags: [
      "案情摘要",
      "认定事实",
      "本院认为",
      "裁判结果"
    ],

    dispute: "劳动争议",

    trial: "二审",

    area: "浙江",

    aiLevel: "高度相关",

    status: "已生效",

    favorite: false
  },

  {
    id: 5,
    title: "刘某与某医疗公司劳动争议案",
    caseNo: "（2020）苏05民终10238号",
    court: "苏州市中级人民法院",
    date: "2020-05-21",

    summary:
      "劳动者离职后加入竞争企业，但原单位未能证明其违反竞业限制协议及泄露商业秘密。",

    tags: [
      "案情摘要",
      "认定事实",
      "本院认为",
      "裁判结果"
    ],

    dispute: "劳动争议",

    trial: "二审",

    area: "江苏",

    aiLevel: "一般相关",

    status: "已生效",

    favorite: true
  },

  {
    id: 6,
    title: "赵某与某互联网公司竞业协议纠纷案",
    caseNo: "（2019）粤01民终99102号",
    court: "广州市中级人民法院",
    date: "2019-10-11",

    summary:
      "劳动者离职后实际控制竞争公司，并持续开展与原单位相同业务，应承担竞业违约责任。",

    tags: [
      "案情摘要",
      "认定事实",
      "本院认为",
      "裁判结果"
    ],

    dispute: "劳动争议",

    trial: "二审",

    area: "广东",

    aiLevel: "高度相关",

    status: "已生效",

    favorite: false
  }
]

// mock.js
// Tab 标签数据
export const tabListData = [
  { key: 'origin', label: '案例原文' },
  { key: 'fact', label: '认定事实' },
  { key: 'court', label: '本院认为' },
  { key: 'judge', label: '裁判结果' }
]

// 判决书主体数据
export const caseDocData = {
  title: '某科技公司与张某竞业限制纠纷二审民事判决书',
  subInfo: '（2024）沪01民终3268号 | 上海市第一中级人民法院 | 2024年6月18日',
  brief: '裁判要旨：劳动者在职期间实际控制并经营与用人单位存在直接竞争关系的企业，使用原单位客户资源获取业务，违反忠实义务及双方竞业约定。',
  sections: [
    {
      id: 'info',
      title: '当事人信息',
      text: '上诉人（原审被告）：张某。被上诉人（原审原告）：某科技有限公司。'
    },
    {
      id: 'process',
      title: '审理经过',
      text: '上诉人张某因与被上诉人某科技有限公司竞业限制纠纷一案，不服一审民事判决，向本院提起上诉。本院依法组成合议庭进行了审理，本案现已审理终结。'
    },
    {
      id: 'find',
      title: '本院查明',
      text: '张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。张某在任职期间参与设立并实际经营一家与某科技有限公司主营业务相同的企业。相关工商资料、客户往来记录及项目合同显示，张某对该企业经营决策具有实质影响，并承接了原公司客户项目。'
    },
    {
      id: 'think',
      title: '本院认为',
      text: '劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。劳动者在劳动关系存续期间负有忠实义务。张某明知双方存在竞业及保密约定，仍从事实质性竞争经营活动，并使用原公司客户信息获取交易机会，已构成违约。原审结合约定金额、行为持续时间及影响程度对违约金作出调整，并无不当。'
    },
    {
      id: 'result',
      title: '裁判结果',
      text: '驳回上诉，维持原判。二审案件受理费由上诉人张某负担。本判决为终审判决。'
    }
  ]
}